import * as ls from 'local-storage';
import { store } from 'redux/store';
import { handleLogout } from 'ComponentsV2/ProjectDashboard/utils/handleLogout';

const API_BASES = [
    process.env.REACT_APP_MYXP_API,
    process.env.REACT_APP_MYXP_API_V2,
    process.env.REACT_APP_MYXP_API_VIRTUAL,
    process.env.REACT_APP_MYXP_API_NOTIFICATION,
];

let logoutInFlight = null;

function myXpOrigins() {
    return API_BASES.filter(Boolean)
        .map((base) => {
            try {
                const { origin } = new URL(base);
                return origin;
            } catch (error) {
                return null;
            }
        })
        .filter(Boolean);
}

function isMyXpApiUrl(url) {
    try {
        const { origin } = new URL(url, window.location.origin);
        return myXpOrigins().includes(origin);
    } catch (error) {
        return false;
    }
}

function isBogusAuthorization(value) {
    if (value == null) return false;
    const trimmed = String(value).trim();
    return (
        trimmed === '' ||
        trimmed === 'Bearer' ||
        trimmed === 'Bearer undefined' ||
        trimmed === 'Bearer null'
    );
}

function withoutBogusAuthorization(headers) {
    if (!headers) return headers;
    if (typeof Headers !== 'undefined' && headers instanceof Headers) {
        const next = new Headers(headers);
        if (isBogusAuthorization(next.get('Authorization'))) {
            next.delete('Authorization');
        }
        return next;
    }
    const next = { ...headers };
    Object.keys(next).forEach((key) => {
        if (
            key.toLowerCase() === 'authorization' &&
            isBogusAuthorization(next[key])
        ) {
            delete next[key];
        }
    });
    return next;
}

function logoutOnce() {
    if (!logoutInFlight) {
        logoutInFlight = Promise.resolve()
            .then(() => handleLogout(false))
            .catch((error) => {
                console.error(error);
            })
            .finally(() => {
                logoutInFlight = null;
            });
    }
    return logoutInFlight;
}

async function validateResponse(res) {
    switch (res.status) {
        case 401: {
            await logoutOnce();
            break;
        }
        case 403: {
            window.location.href = '/?err=no_access';
            break;
        }
        default:
            break;
    }
    return res;
}

async function fetcher(request, opt, signal, includeCredentials) {
    const { ignoreResponseValidation, ...rest } = opt || {};
    const options = {
        ...rest,
        headers: withoutBogusAuthorization(rest.headers),
        signal,
    };
    if (includeCredentials && isMyXpApiUrl(request)) {
        options.credentials = 'include';
    }
    const res = await fetch(request, options);
    if (!ignoreResponseValidation) {
        await validateResponse(res);
    }
    return res;
}

function addRequiredParams(url, isImgUpload) {
    try {
        const user = store?.getState()?.user;
        const urlObj = new URL(url, window.location.origin);
        const { searchParams } = urlObj;
        if (ls.get('sponsorAuth')) {
            const hostUrlObj = new URL(window.location.href);
            const companyId = hostUrlObj.pathname.includes('company/')
                ? hostUrlObj.pathname.split('/')[2]
                : '';
            const exhibitorCompanyProfileId =
                companyId ||
                searchParams.get('exhibitorCompanyProfileId') ||
                user?.exhibitorCompanyProfileId;
            if (exhibitorCompanyProfileId && !isImgUpload) {
                searchParams.set(
                    'exhibitorCompanyProfileId',
                    exhibitorCompanyProfileId
                );
            }
        }
        return urlObj.toString();
    } catch (error) {
        return url;
    }
}

// eslint-disable-next-line import/prefer-default-export
export async function apiInterceptor(
    url,
    options,
    includeCredentials = true,
    isImgUpload
) {
    const requestUrl = addRequiredParams(url, isImgUpload) || url;
    const controller = new AbortController();
    try {
        const res = await fetcher(
            requestUrl,
            options,
            controller.signal,
            includeCredentials
        );
        return Object.assign(res, {
            response: res,
            abort: () => controller.abort(),
        });
    } catch (error) {
        console.error(error);
        throw error;
    }
}
